/* eslint-disable no-unused-vars */
import React from 'react';
import Modal from './index';
import style from './modal.module.scss';
import Button from 'controls/buttons/submit';

export default function ErrorModal({
  errorText,
  onClose,
}: {
  errorText: string;
  onClose: () => void;
}) {
  return (
    <Modal
      open={true}
      onClose={onClose}
      innerSX={{
        borderWidth: 2,
        borderColor: 'error.main',
        borderStyle: 'solid',
      }}
    >
      <div className={style.error}>
        {errorText}
        <div className={style.buttons}>
          <Button className={style.close} onClick={onClose}>
            Закрыть
          </Button>
        </div>
      </div>
    </Modal>
  );
}
